<style lang="stylus">
    .ReplaceClr-mask
        // modal-mask()
        .ReplaceClr-modal
            width 514px
            height auto
            .dialog-slot
                .ReplaceClr-box
                    display flex
                    flex-wrap wrap
                    align-items center
                    &.check-box
                        .ivu-checkbox
                            margin-right 10px
                            &:not(.ivu-checkbox-checked)
                                .ivu-checkbox-inner
                                    background-color var(--bg-color-tertiary)
                    .ReplaceClr-Title
                        font-weight bold
                        flex 1
                    .ReplaceClr-ColorMenu
                        position relative
                        width 24px
                        height 24px
                        margin-right 8px
                        &:not(.ban):hover
                            background-color var(--bg-color-replacecrl-color-menu)
                        &.ban
                            cursor not-allowed
                            .item-icon-center
                                opacity 0.4
                                filter grayscale(1)
                        .item-icon-center
                            pointer-events: none;
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 24px;
                            height: 24px;
                            color: var(--svg-color-primary);
                    .ReplaceClr-SelectAll:hover
                        color var(--themeColor)
                    .ReplaceClr-colorBlock
                        position relative
                        width 32px
                        height 32px
                        border-radius 3px
                        border 0.747231px solid var(--border-color-box-6)
                        overflow hidden
                        margin-right 16px
                        margin-bottom 16px
                        &:nth-child(10),&:nth-child(20),&:nth-child(30)
                            margin-right 0px
                        .ReplaceClr-colorBG
                            width 100%
                            height 100%
                        .ReplaceClr-checkedFlag
                            display none
                            .ReplaceClr-checkedBG
                                position absolute
                                width 25.53px
                                height 24.02px
                                left 17.44px
                                top 19.53px
                                background #D5D7DB
                                border: 1px solid #E4E5E9
                                box-sizing border-box
                                transform rotate(-46.45deg)
                            .item-icon
                                width 7px
                                height 5px
                                position absolute
                                left 22px
                                top 24px
                                stroke #ffffff
                                fill none
                        &.isChecked
                            .ReplaceClr-checkedFlag
                                display block
                                .ReplaceClr-checkedBG
                                    background #5FC181
                                    border 1px solid #82D9AA
                        &:hover
                            .ReplaceClr-checkedFlag
                                display block
            .ReplaceClr-actionList
                position absolute
                left 29px
                bottom 40px
                z-index 1
                .ReplaceClr-action
                    float left
                    position relative
                    width 24px
                    height 24px
                    margin-right 16px
                    cursor pointer
                    border-radius 2px
                    &:not(.ban):hover
                        background-color var(--bg-color-replacecrl-color-menu)
                    .item-icon-center
                        position absolute
                        width 24px
                        height 24px
                        pointer-events none
                        top 50%
                        left 50%
                        transform translate(-50%, -50%)
                        color var(--svg-color-gray-42-secondary)
                    &.ban
                        cursor not-allowed
                        .item-icon-center
                            opacity 0.4
                            filter grayscale(1)
            .dialog-btnbox-normal
                padding 0
                margin-top 22px
                .dialog-btn-ok
                    margin-right 0
</style>

<template>
    <div class="ReplaceClr-mask">
        <Dialog
            class="ReplaceClr-modal"
            :title="$t('title')"
            :isShow="true"
            :showVipIcon="!Boolean(vip)"
            showFooter="true"
            @ok="confirm"
            @close="cancel"
        >
            <div v-show="pageItemFillClr.length">
                <div class="ReplaceClr-box" style="margin-bottom: 16px">
                    <div class="ReplaceClr-Title">{{ $t("fillTitle") }}</div>
                    <div class="ReplaceClr-ColorMenu" :class="{ ban: !hasSelectFill }" @click="showPalette($event, 'fill')">
                        <iconSymbol
                            class="item-icon-center"
                            :name="`fillcolor${isDarkTheme() ? '-dark' : ''}`"
                            :style="`fill:${hasSelectFill ? fillColor : ''}`"
                        ></iconSymbol>
                    </div>
                    <div class="ReplaceClr-SelectAll" @click="selectAllFill">{{ isSelectFillAll ? $t("deselectAll") : $t("selectAll") }}</div>
                </div>
                <div class="ReplaceClr-box">
                    <div
                        class="ReplaceClr-colorBlock"
                        v-for="(item, i) in pageItemFillClr"
                        :key="item"
                        :class="{ isChecked: checkFill[i] }"
                        @click="clickCheck('fill', i)"
                    >
                        <div class="ReplaceClr-colorBG" :style="{ backgroundColor: item }"></div>
                        <div class="ReplaceClr-checkedFlag">
                            <div class="ReplaceClr-checkedBG"></div>
                            <iconSymbol class="item-icon" :name="'replaceClr-check'"></iconSymbol>
                        </div>
                    </div>
                </div>
                <div class="ReplaceClr-box check-box" style="margin-bottom: 24px">
                    <Checkbox v-model="fillWithLine">{{ $t("fillWithLine") }}</Checkbox>
                </div>
            </div>
            <div v-show="pageItemLineClr.length">
                <div class="ReplaceClr-box" style="margin-bottom: 16px">
                    <div class="ReplaceClr-Title">{{ $t("lineTitle") }}</div>
                    <div class="ReplaceClr-ColorMenu" :class="{ ban: !hasSelectLine }" @click="showPalette($event, 'line')">
                        <iconSymbol
                            class="item-icon-center"
                            :name="`fillline${isDarkTheme() ? '-dark' : ''}`"
                            :style="`fill:${hasSelectLine ? lineColor : ''}`"
                        ></iconSymbol>
                    </div>
                    <div class="ReplaceClr-SelectAll" @click="selectAllLine">{{ isSelectLineAll ? $t("deselectAll") : $t("selectAll") }}</div>
                </div>
                <div class="ReplaceClr-box">
                    <div
                        class="ReplaceClr-colorBlock"
                        v-for="(item, i) in pageItemLineClr"
                        :key="item"
                        :class="{ isChecked: checkLine[i] }"
                        @click="clickCheck('line', i)"
                    >
                        <div class="ReplaceClr-colorBG" :style="{ backgroundColor: item }"></div>
                        <div class="ReplaceClr-checkedFlag">
                            <div class="ReplaceClr-checkedBG"></div>
                            <iconSymbol class="item-icon" :name="'replaceClr-check'"></iconSymbol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ReplaceClr-actionList">
                <div class="ReplaceClr-action" :class="{ ban: !canUndo }" @click="undo">
                    <iconSymbol class="item-icon-center" :name="'undo'"></iconSymbol>
                </div>
                <div class="ReplaceClr-action" :class="{ ban: !canRedo }" @click="redo">
                    <iconSymbol class="item-icon-center" :name="'redo'"></iconSymbol>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class ReplaceColor extends Vue {
        @Inject()
        ["showMessage"];

        confirm() {
            if (!this.vip) {
                this.$openBuyPage("Replace");
                return;
            }
            this.closeModal();
            let view = window["_view"];
            view && view.replaceSimilarColor();
        }

        cancel() {
            this.closeModal();
            let view = window["_view"];
            view && view.rejectReplaceColor();
        }

        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.fillWithLine = false;
        }

        clickCheck(type: string, index: number) {
            if (type == "fill") {
                if (this.checkFill[index] != null) {
                    this.$set(this.checkFill, index, !this.checkFill[index]);
                    let idx = this.oneSelectFillIndex;
                    if (idx != -1) this.fillColor = this.pageItemFillClr[idx];
                }
            } else {
                if (this.checkLine[index] != null) {
                    this.$set(this.checkLine, index, !this.checkLine[index]);
                    let idx = this.oneSelectLineIndex;
                    if (idx != -1) this.lineColor = this.pageItemLineClr[idx];
                }
            }
        }

        selectAllFill() {
            let selected = this.isSelectFillAll;
            for (let i = 0; i < this.checkFill.length; i++) this.$set(this.checkFill, i, !selected);
        }

        selectAllLine() {
            let selected = this.isSelectLineAll;
            for (let i = 0; i < this.checkLine.length; i++) this.$set(this.checkLine, i, !selected);
        }

        showPalette(e, t) {
            if (t == "fill") {
                if (!this.hasSelectFill) return;
            } else {
                if (!this.hasSelectLine) return;
            }
            let node = e.target;
            let payload = {
                type: t == "fill" ? this.fmtType.fill : this.fmtType.line,
                index: 0,
            };
            let fillwithLine = t == "fill" && this.fillWithLine;
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: fillwithLine ? "ReplaceFillWithLine" : "ReplaceColor" });
            });
        }

        undo() {
            if (!this.canUndo) return;
            let view = window["_view"];
            view && view.undoReplaceColor();
        }

        redo() {
            if (!this.canRedo) return;
            let view = window["_view"];
            view && view.redoReplaceColor();
        }

        mounted() {
            this.fillWithLine = false;
            this.checkFill = [];
            for (let i = 0; i < this.pageItemFillClr.length; i++) {
                this.checkFill.push(false);
            }

            this.checkLine = [];
            for (let i = 0; i < this.pageItemLineClr.length; i++) {
                this.checkLine.push(false);
            }
        }

        created() {}

        get pageItemFillClr() {
            return this.$store.state.ui.pageItemFillClr;
        }
        get pageItemLineClr() {
            return this.$store.state.ui.pageItemLineClr;
        }
        get fillColor() {
            return this.$store.state.ui.replaceFillColor;
        }
        set fillColor(clr) {
            this.$store.commit("setStatus", { type: "replaceFillColor", data: clr });
        }
        get lineColor() {
            return this.$store.state.ui.replaceLineColor;
        }
        set lineColor(clr) {
            this.$store.commit("setStatus", { type: "replaceLineColor", data: clr });
        }
        get checkFill() {
            return this.$store.state.ui.replaceFillCheck;
        }
        set checkFill(list) {
            this.$store.commit("setStatus", { type: "replaceFillCheck", data: list });
        }
        get checkLine() {
            return this.$store.state.ui.replaceLineCheck;
        }
        set checkLine(list) {
            this.$store.commit("setStatus", { type: "replaceLineCheck", data: list });
        }
        get canUndo() {
            return this.$store.state.ui.canUndoReplace;
        }
        get canRedo() {
            return this.$store.state.ui.canRedoReplace;
        }
        get isSelectFillAll() {
            for (let i = 0; i < this.checkFill.length; i++) if (!this.checkFill[i]) return false;
            return true;
        }
        get hasSelectFill() {
            for (let i = 0; i < this.checkFill.length; i++) if (this.checkFill[i]) return true;
            return false;
        }
        get oneSelectFillIndex() {
            let index = -1;
            for (let i = 0; i < this.checkFill.length; i++)
                if (this.checkFill[i]) {
                    if (index == -1) index = i;
                    else return -1;
                }
            return index;
        }
        get isSelectLineAll() {
            for (let i = 0; i < this.checkLine.length; i++) if (!this.checkLine[i]) return false;
            return true;
        }
        get hasSelectLine() {
            for (let i = 0; i < this.checkLine.length; i++) if (this.checkLine[i]) return true;
            return false;
        }
        get oneSelectLineIndex() {
            let index = -1;
            for (let i = 0; i < this.checkLine.length; i++)
                if (this.checkLine[i]) {
                    if (index == -1) index = i;
                    else return -1;
                }
            return index;
        }
        get fillWithLine() {
            return this.$store.state.ui.replaceFillWithLine;
        }
        set fillWithLine(flag) {
            this.$store.commit("setStatus", { type: "replaceFillWithLine", data: flag });
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "批量修改颜色",
    "fillTitle": "填充色",
    "lineTitle": "线条颜色",
    "selectAll": "全选",
    "deselectAll": "取消全选",
    "fillWithLine": "是否同时修改线条颜色",
    "confirm": "确定",
    "cancel": "取消"
  },
  "en": {
    "title": "Replace Color",
    "fillTitle": "Fill Color",
    "lineTitle": "Line Color",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "fillWithLine": "Set the same color for lines",
    "confirm": "OK",
    "cancel": "Cancel"
  },
  "fr": {
    "title": "Remplacer la couleur",
    "fillTitle": "Couleur de remplissage",
    "lineTitle": "Couleur de la ligne",
    "selectAll": "Sélectionner tous",
    "deselectAll": "Désélectionner tout",
    "fillWithLine": "Définir la même couleur pour les lignes",
    "confirm": "Confirmer",
    "cancel": "Annuler"
  },
  "pt": {
    "title": "Substituir Cor",
    "fillTitle": "Preencher cor",
    "lineTitle": "Cor da Linha",
    "selectAll": "Selecionar Tudo",
    "deselectAll": "Desmarcar todos",
    "fillWithLine": "Defina a mesma cor para as linhas",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "es": {
    "title": "Reemplazar color",
    "fillTitle": "Color de relleno",
    "lineTitle": "Color de linea",
    "selectAll": "Seleccionar Todo",
    "deselectAll": "Deseleccionar todo",
    "fillWithLine": "Establecer el mismo color para las líneas",
    "confirm": "Aceptar",
    "cancel": "Cancelar"
  },
  "de": {
    "title": "Farbe ersetzen",
    "fillTitle": "Füllfarbe",
    "lineTitle": "Linienfarbe",
    "selectAll": "Alle auswählen",
    "deselectAll": "Alle abwählen",
    "fillWithLine": "Gleiche Farbe für Linien einstellen",
    "confirm": "Sichern",
    "cancel": "Abbrechen"
  },
  "jp": {
    "title": "色の置換",
    "fillTitle": "塗りつぶしの色",
    "lineTitle": "線の色",
    "selectAll": "すべて選択",
    "deselectAll": "すべての選択を解除",
    "fillWithLine": "線に同じ色を設定する",
    "confirm": "確認",
    "cancel": "キャンセル"
  },
  "it": {
    "title": "Sostituisci Colore",
    "fillTitle": "Colore di riempimento",
    "lineTitle": "Colore della Linea",
    "selectAll": "Seleziona Tutto",
    "deselectAll": "Deseleziona Tutto",
    "fillWithLine": "Imposta lo stesso colore per le linee",
    "confirm": "OK",
    "cancel": "Annulla"
  },
  "tw": {
    "title": "替換顏色",
    "fillTitle": "顏色填充",
    "lineTitle": "線條顏色",
    "selectAll": "選擇全部",
    "deselectAll": "取消全部選擇",
    "fillWithLine": "為線條設置相同的顏色",
    "confirm": "確認",
    "cancel": "取消"
  },
  "kr": {
    "title": "대량으로 색깔 수정",
    "fillTitle": "채운 색깔",
    "lineTitle": "라인 색깔",
    "selectAll": "전체 선택",
    "deselectAll": "전체 선택 취소",
    "fillWithLine": "라인에 동일한 색깔 설정",
    "confirm": "확인 ",
    "cancel": "취소 "
  }
}
</i18n>
